import React from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { fetchFranchiseeList } from 'actions';
import MultiselectFilter from './MultiselectFilter';

class FranchiseeFilter extends React.Component {
    static propTypes = {
        franchiseeList: ImmutablePropTypes.list.isRequired,
        defaultSelected: PropTypes.arrayOf(PropTypes.string),
        onChange: PropTypes.func.isRequired,
    }

    static defaultProps = {
        defaultSelected: []
    }

    componentDidMount() {
        const { dispatch, franchiseeList } = this.props;

        if (franchiseeList.size === 0) {
            dispatch(fetchFranchiseeList());
        }
    }

    render() {
        const { franchiseeList, defaultSelected, onChange } = this.props;
        const franchiseeOptions = franchiseeList.toJS().map(franchisee => ({
            text: franchisee.name,
            value: franchisee.id,
        }));

        return (
            <MultiselectFilter
                title={ I18n.t('admin.franchisee') }
                options={ franchiseeOptions }
                defaultSelected={ defaultSelected }
                onChange={ onChange }
            />
        );
    }
}

export default connect(state => ({
    franchiseeList: state.admin.get('franchiseeList')
}))(FranchiseeFilter);
